import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { DropdownItem } from '@com-delta-omnichannel/mach-core-js';
import {
  BookWidgetFieldInfoTypes,
  BookWidgetFieldUpdateTypes
} from '../../../../constants/book-widget.constants';

import { BookWidgetFieldUpdateEvent } from '../../../../models/book-widget-fields-update-info.interfaces';
import { SelectedRange } from '../../../../models/common.interfaces';
import {
  SearchModalEvent,
  SearchModalEventType
} from '../../../../models/search-modal-events-object.interface';
import {
  BestFareOptionsMachCoreComponent,
  DatePickerMachCoreComponent,
  MeetingCodeMachCoreComponent,
  OneWayRoutePickerMachCoreComponent,
  OptionsExpanderMachCoreComponent,
  SelectMachCoreComponent
} from '../../../common';
import { HomeBookWidgetBaseComponent } from '../home-book-widget-base/home-book-widget-base.component';

@Component({
  selector: 'idp-home-book-widget-mobile-ow-rt',
  standalone: true,
  imports: [
    CommonModule,
    OptionsExpanderMachCoreComponent,
    OneWayRoutePickerMachCoreComponent,
    SelectMachCoreComponent,
    DatePickerMachCoreComponent,
    BestFareOptionsMachCoreComponent,
    MeetingCodeMachCoreComponent
  ],
  templateUrl: './home-book-widget-mobile-ow-rt.component.html'
})
export class HomeBookWidgetOwRtMobileComponent extends HomeBookWidgetBaseComponent {
  protected passengerDropdownLabelFn = (item: DropdownItem | undefined) =>
    item ? item.value : '';

  onViewSearchOptionsHandler() {
    this.viewSearchOptionEvent.emit();
  }

  infoIconClickHandler(sourceIcon: BookWidgetFieldInfoTypes, event: Event) {
    if (sourceIcon) {
      this.handleTooltipAnalytics(sourceIcon, event);
      this.infoIconClick.emit(sourceIcon);
    }
  }

  onDropdownSelectionChange(
    event: DropdownItem,
    bookWidgetFieldUpdateType: BookWidgetFieldUpdateTypes
  ) {
    const emitValue: BookWidgetFieldUpdateEvent = {
      data: event.value,
      type: bookWidgetFieldUpdateType
    };
    this.bookWidgetFieldChange.emit(emitValue);
  }

  onDateSelectionChange(
    selectedRange: SelectedRange,
    bookWidgetFieldUpdateType: BookWidgetFieldUpdateTypes,
    flightIndex: number
  ) {
    const emitValue: BookWidgetFieldUpdateEvent = {
      data: {
        selectedRange,
        flightIndex
      },
      type: bookWidgetFieldUpdateType
    };
    this.bookWidgetFieldChange.emit(emitValue);
  }

  onToggleChange(
    event: Event,
    bookWidgetFieldUpdateType: BookWidgetFieldUpdateTypes
  ) {
    const target = event.target as HTMLInputElement;
    const emitValue: BookWidgetFieldUpdateEvent = {
      data: target.checked,
      type: bookWidgetFieldUpdateType
    };
    this.bookWidgetFieldChange.emit(emitValue);
  }

  onInputFieldChange(
    event: Event,
    bookWidgetFieldUpdateType: BookWidgetFieldUpdateTypes
  ) {
    const target = event.target as HTMLInputElement;
    const emitValue: BookWidgetFieldUpdateEvent = {
      data: target.value,
      type: bookWidgetFieldUpdateType
    };
    this.bookWidgetFieldChange.emit(emitValue);
  }

  expandSearchView(event: SearchModalEvent<SearchModalEventType>) {
    if (!this.viewSearchOptionExpanded && event.type === 'modalClose')
      this.onViewSearchOptionsHandler();
  }
}
